import _ from 'lodash';
import { numFormat } from './numFormat';

function convertStringToHex(inputString: string): string {
  const arr = [];
  for (let i = 0; i < inputString.length; i++) {
    arr[i] = ('00' + inputString.charCodeAt(i).toString(16)).slice(-2);
  }
  return arr.join('');
}

function convertNumberToHex(inputNumber: number): string {
  return ('00'+ inputNumber.toString(16)).slice(-2);
}

function convertHexToBase64(inputHexValue: string): string {
  // @ts-ignore
  const updatedString = inputHexValue.match(/\w{2}/g).map((a: string) => {
    return String.fromCharCode(parseInt(a, 16));
  }).join('');
  const base64String = btoa(updatedString);
  return base64String;
}

export function qrCodeValue({ companyDetails, docDetails, total, vat }: any) {
  if(!companyDetails || !docDetails) return '';
  const tagLengthValues = [
    { tag: 1, type: 'companyName' },
    { tag: 2, type: 'vatNo' },
    { tag: 3, type: 'timestamp' },
    { tag: 4, type: 'totalValue' },
    { tag: 5, type: 'vatValue' },
  ]
  let hexValue = '';
  for(let i = 0; i < tagLengthValues.length; i++) {
    const tagHex = convertNumberToHex(tagLengthValues[i].tag);
    let valueHex = '';
    let lengthHex = '';
    if(tagLengthValues[i].type == 'companyName') {
      const value: string = _.get(companyDetails, 'name.en');
      lengthHex = convertNumberToHex(value.length);
      valueHex = convertStringToHex(value);
    }
    if(tagLengthValues[i].type == 'vatNo') {
      const value: string = `${_.get(companyDetails, 'vatNo')}`;
      lengthHex = convertNumberToHex(value.length);
      valueHex = convertStringToHex(value);
    }
    if(tagLengthValues[i].type == 'timestamp') {
      const value: string = _.get(docDetails, 'createdAt');
      lengthHex = convertNumberToHex(value.length);
      valueHex = convertStringToHex(value);
    }
    if(tagLengthValues[i].type == 'totalValue') {
      const value = numFormat(total) + '';
      lengthHex = convertNumberToHex(value.length);
      valueHex = convertStringToHex(value);
    }
    if(tagLengthValues[i].type == 'vatValue') {
      const value = numFormat(vat) + '';
      lengthHex = convertNumberToHex(value.length);
      valueHex = convertStringToHex(value);
    }
    hexValue = hexValue + tagHex + lengthHex + valueHex;
  }
  if(!hexValue) return '';
  const base64String = convertHexToBase64(hexValue);
  return base64String;
}